<template>
  <div class="row-fluid">
    <div class="container">
      <div v-if="loadingMethods">
        <img src="/layouts/main/styles/images/spinner.gif" />
        Calculating taxes and shipping costs...
      </div>
      <div class="row" v-if="!loadingMethods">
        <div class="col-xs-12 col-sm-6">
          <div id="shiptypeHolder">
            <div id="standardShipping" v-if="shipType == 'standardShipping'">
              <h3>Select a shipping method:</h3>
              <div id="shipServiceList">
                <div
                  v-for="(method, methodIndex) in methods"
                  :key="method.name"
                  class="marginbottom5"
                >
                  <div
                    class="radio"
                    v-for="(option, optionIndex) in method.opts"
                    :key="option.shipMethod"
                  >
                    <label>
                      <input
                        type="radio"
                        name="shipping"
                        :value="methodIndex + 1 + ':' + (optionIndex + 1)"
                        @change="updateShippingType(methodIndex + 1 + ':' + (optionIndex + 1))"
                        :checked="isChecked(option, methodIndex, optionIndex)"
                      />
                      <span class="shippingName">{{ option.shipMethod }}</span>
                      - ${{ option.calcShipAmt.toFixed(2) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="shipType == 'noShip'" v-html="labels[1063]"></div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-5 col-sm-offset-1">
          <div id="shipnotesHolder">
            Additional Shipping Instructions
            <small>(Optional)</small>
            <textarea
              id="ship_note"
              class="form-control input-sm"
              name="ship_note"
              rows="6"
              v-model="shipNotes"
            ></textarea>
          </div>
        </div>
      </div>

      <hr />
      <cart-footer>
        <template v-slot:left><div v-html="labels[1074]"></div></template>
        <template v-slot:center><div v-html="labels[1488]"></div></template>
        <template v-slot:right>
          <div class="priceDisplayBox">
            <Checkout-Total-Box />
          </div>
          <button
            rel="nofollow"
            :disabled="!shippingSet"
            :class="continueBtnClass"
            class="btn btn-primary btn-block btn-continue"
            @click="proceedToNextStep"
            id="ship-address-next-vue"
          >
            {{ labels[1060] }}
            <span>&rsaquo;</span>
            <!-- CONTINUE -->
          </button>
        </template>
      </cart-footer>
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted, watch } from '@vue/composition-api'
  import router from '../router'
  import useAlerts from '../../shared/composables/useAlerts'
  import useCMS from '../../shared/composables/useCMS'
  import useShipping from '../composables/useShipping'
  import CheckoutTotalBox from '../components/CheckoutTotalBox'
  import CartFooter from '../components/CartFooter'

  export default {
    name: 'CheckoutShipMethod',
    setup: function() {
      const { labels } = useCMS()
      const { addAlert } = useAlerts()
      const {
        methods,
        shipMethod,
        shippingSet,
        shipNotes,
        setDefaultShippingOption,
        setShipMethod,
        shipType,
      } = useShipping()

      const continueBtnClass = computed(() => '')
      const loadingMethods = ref(true)

      const isChecked = (method) => {
        if (shipMethod.value !== undefined && method.shipMethod == shipMethod.value.shipMethod) {
          return true
        }
        return false
      }

      const updateShippingType = (selection) => {
        var indexes = selection.split(':')
        var option = methods.value[indexes[0] - 1].opts[indexes[1] - 1]
        setShipMethod(option)
      }

      const proceedToNextStep = () => {
        router.push('/checkout/billing')
        // router.push('/checkout/review');
      }

      watch(methods, () => {
        setDefaultShippingOption()
          .then(function(response) {
            loadingMethods.value = response
          })
          .catch((error) => {
            addAlert('An error occurred setting shipping option.', 'alert-danger', 5000)
            console.log(error)
          })
      })

      onMounted(() => {
        setDefaultShippingOption()
          .then(function(response) {
            loadingMethods.value = response
          })
          .catch((error) => {
            addAlert('An error occurred setting shipping option.', 'alert-danger', 5000)
            console.log(error)
          })
      })

      return {
        labels,
        continueBtnClass,
        loadingMethods,
        methods,
        shippingSet,
        shipNotes,
        isChecked,
        proceedToNextStep,
        updateShippingType,
        shipType,
      }
    },
    components: {
      CheckoutTotalBox,
      CartFooter,
    },
  }
</script>
